import { generator } from  '../event-listener';

export const OnClick = generator('onClick');
export const OnDoubleClick = generator('onDoubleClick');
export const OnContextMenuClick = generator('onContextMenu');
